import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../input';

/**
 * @param {
 *  objectName: string,
 *  formik: Formik,
 *  translationPrefix: string
 * } props
 * @returns
 */
const InchargePersonForm = ({
  objectName = 'inchargePersonDetails',
  formik,
  translationPrefix,
}) => {
  const { t } = useTranslation();

  const inchargePersonFormikValues = formik.values?.[objectName] || {};

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-6">
      <div className="col-span-1">
        <Input
          name={'firstName'}
          id={'firstName'}
          label={t(`${translationPrefix}.firstName.label`)}
          placeholder={t(`${translationPrefix}.firstName.placeholder`)}
          type={'text'}
          defaultValue={inchargePersonFormikValues.firstName}
          onChange={(e) => {
            formik.setFieldValue(objectName + '.firstName', e.target.value);
          }}
          error={formik.touched?.[objectName]?.firstName && formik.errors?.[objectName]?.firstName}
        />
      </div>

      <div className="col-span-1">
        <Input
          name={'lastName'}
          id={'lastName'}
          label={t(`${translationPrefix}.lastName.label`)}
          placeholder={t(`${translationPrefix}.lastName.placeholder`)}
          type={'text'}
          defaultValue={inchargePersonFormikValues.lastName}
          onChange={(e) => {
            formik.setFieldValue(objectName + '.lastName', e.target.value);
          }}
          error={formik.touched?.[objectName]?.lastName && formik.errors?.[objectName]?.lastName}
        />
      </div>

      <div className="col-span-1">
        <Input
          name={'function'}
          id={'function'}
          label={t(`${translationPrefix}.function.label`)}
          placeholder={t(`${translationPrefix}.function.placeholder`)}
          type={'text'}
          defaultValue={inchargePersonFormikValues.function}
          onChange={(e) => {
            formik.setFieldValue(objectName + '.function', e.target.value);
          }}
          error={formik.touched?.[objectName]?.function && formik.errors?.[objectName]?.function}
        />
      </div>

      <div className="col-span-1">
        <Input
          name={'email'}
          id={'email'}
          label={t(`${translationPrefix}.email.label`)}
          placeholder={t(`${translationPrefix}.email.placeholder`)}
          type={'email'}
          defaultValue={inchargePersonFormikValues.email}
          onChange={(e) => {
            formik.setFieldValue(objectName + '.email', e.target.value);
            if (objectName === 'inchargePersonDetails') {
              formik.setFieldValue('emailConsent.email', e.target.value);
            }
          }}
          error={formik.touched?.[objectName]?.email && formik.errors?.[objectName]?.email}
        />
      </div>

      <div className="col-span-1">
        <Input
          name={'phone'}
          id={'phone'}
          label={t(`${translationPrefix}.phone.label`)}
          placeholder={t(`${translationPrefix}.phone.placeholder`)}
          type={'tel'}
          defaultValue={inchargePersonFormikValues.phone}
          onChange={(e) => {
            formik.setFieldValue(objectName + '.phone', e.target.value);
          }}
          error={formik.touched?.[objectName]?.phone && formik.errors?.[objectName]?.phone}
        />
      </div>
    </div>
  );
};

export default InchargePersonForm;
